import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <>
      <SEO 
        title="Siden blev ikke fundet" 
        description="Beklager, men den side du leder efter findes ikke eller er blevet flyttet." 
      />

      <section className="min-h-[70vh] flex items-center justify-center bg-brand-cream px-6 py-16">
        <div className="max-w-md w-full text-center flex flex-col items-center gap-6">
          <div className="w-16 h-16 rounded-full bg-brand-beige flex items-center justify-center text-brand-brown text-2xl">
            <i className="fa-light fa-compass-slash" />
          </div>
          
          <div className="flex flex-col gap-2">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-brand-brown/70">Fejl 404</span>
            <h1 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark">
              Siden blev ikke fundet
            </h1>
          </div>

          <p className="text-brand-brown text-sm leading-relaxed">
            Beklager, men den side du leder efter findes ikke, er blevet slettet eller er blevet flyttet til en ny adresse.
          </p>

          <Link
            to="/"
            className="px-6 py-3 bg-brand-dark text-brand-cream font-medium rounded-brand hover:bg-brand-brown transition-colors duration-200 shadow-md"
          >
            Gå til forsiden
          </Link>
        </div>
      </section>
    </>
  );
}
